// Animated Store Status Badge — 8 statuses with dramatic VFX
import React from 'react';

const STATUSES = {
  open:                { emoji: '🟢', label: 'Shop Open',           bg: 'bg-emerald-500', text: 'text-white',  vfx: 'animate-pulse' },
  closed:              { emoji: '🔴', label: 'Shop Closed',         bg: 'bg-rose-600',    text: 'text-white',  vfx: '' },
  ready:               { emoji: '⚡',  label: 'Ready to Attend',     bg: 'bg-cyan-500',    text: 'text-slate-900', vfx: 'animate-pulse' },
  rushed:              { emoji: '⏳', label: 'Rushed',              bg: 'bg-amber-500',   text: 'text-slate-900', vfx: 'animate-bounce-slow' },
  not_ready:           { emoji: '⏸',  label: 'Not Ready to Attend', bg: 'bg-slate-500',   text: 'text-white',  vfx: '' },
  waiting:             { emoji: '👀', label: 'Waiting for You',     bg: 'bg-purple-500',  text: 'text-white',  vfx: 'animate-pulse' },
  too_many_clients:    { emoji: '🚧', label: 'Too Many Clients',    bg: 'bg-orange-600',  text: 'text-white',  vfx: 'animate-blink' },
  book_appointment:    { emoji: '📅', label: 'Book Your Appointment', bg: 'bg-gradient-to-r from-fuchsia-500 to-pink-500', text: 'text-white', vfx: 'animate-glow-shift' },
};

export default function StoreStatusBadge({ status, size = 'md', onClick }) {
  if (!status || !status.value) return null;
  const cfg = STATUSES[status.value];
  if (!cfg) return null;
  const sizeCls = size === 'lg' ? 'px-4 py-2 text-sm' : 'px-3 py-1.5 text-xs';
  const isClickable = !!onClick;
  return (
    <div onClick={onClick}
         className={`inline-flex items-center gap-1.5 rounded-full font-black shadow-lg ${sizeCls} ${cfg.bg} ${cfg.text} ${cfg.vfx} ${isClickable ? 'cursor-pointer hover:scale-105 transition-transform' : ''}`}
         data-testid={`store-status-${status.value}`}
         role={isClickable ? 'button' : undefined}
         tabIndex={isClickable ? 0 : undefined}>
      <span className="text-base leading-none">{cfg.emoji}</span>
      <span className="uppercase tracking-wider">{cfg.label}</span>
      {isClickable && status.value === 'book_appointment' && <span className="text-[9px] opacity-80 ml-1">👆 Tap to book</span>}
      <style>{`
        @keyframes blink { 0%,100% { opacity: 1; } 50% { opacity: 0.55; } }
        .animate-blink { animation: blink 0.8s ease-in-out infinite; }
        @keyframes bounce-slow { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
        .animate-bounce-slow { animation: bounce-slow 1.5s ease-in-out infinite; }
        @keyframes glow-shift { 0%,100% { filter: brightness(1) saturate(1); box-shadow: 0 0 15px rgba(236,72,153,0.6); } 50% { filter: brightness(1.3) saturate(1.5); box-shadow: 0 0 30px rgba(236,72,153,1); } }
        .animate-glow-shift { animation: glow-shift 1.6s ease-in-out infinite; }
      `}</style>
    </div>
  );
}

export const STATUS_OPTIONS = Object.entries(STATUSES).map(([k, v]) => ({ value: k, ...v }));
